<mat-drawer-container *ngIf="selectedCategory != undefined" class="container" [@backgroundSelected]="selectedCategory.id" id="content" >
	<mat-drawer *ngIf="!isLoading" fxHide.lt-md mode="side" opened [@backgroundSelected]="selectedCategory.id">
		<div fxLayout="column" fxLayoutAlign="space-around center" class="categories-banner">
			<div *ngFor="let category of questionnaire;" fxLayout="column" (click)="showCategory(category)" [@isSelected]="selectedCategory.id == category.id ? 'selected' : 'unselected'">
				<img [src]="'assets/images/cat'+category.id+'.svg'"/>
				<h5>{{category.title}}</h5>
			</div>
		</div>
	</mat-drawer>
	<mat-drawer-content  [ngClass]="{'cat-a-theme': selectedCategory.id == 'A','cat-b-theme': selectedCategory.id == 'B','cat-c-theme': selectedCategory.id == 'C' }">
		<div *ngIf="isLoading" fxFill fxLayout="column" fxLayoutAlign="center center">
			<mat-spinner></mat-spinner>
			<br/>
			<h2>Calculando resultados...</h2>
		</div>
		<div *ngIf="!isLoading">
			<div fxLayout="row" fxHide fxShow.lt-md fxLayoutAlign="space-around center" class="categories-banner">
				<div *ngFor="let category of questionnaire;" fxLayout="column" (click)="showCategory(category)" [@isSelected]="selectedCategory.id == category.id ? 'selected' : 'unselected'">
					<img [src]="'assets/images/cat'+category.id+'.svg'"/>
					<h5>{{category.title}}</h5>
				</div>
			</div>
			<div fxShow fxHide.lt-md class="element-container title-container" [@titleBackgroundSelected]="selectedCategory.id" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="20px">
				<div fxLayout="row" fxLayoutAlign="center center">
					<img [src]="'assets/images/cat'+selectedCategory.id+'.svg'"/>
				</div>
				<h3>{{ selectedCategory.title }}</h3>
			</div>
			<div id="instructions">
				<p><strong>Coloque el puntero en la declaración que más se acerque a lo realizado por su empresa, o en el centro si ambas son parcialmente ciertas.</strong></p>
			</div>
			<mat-vertical-stepper (selectionChange)="selectionChange($event)" #stepper>
				<div *ngFor="let subcategory of selectedCategory.subcategories;last as isLast; first as isFirst; index as subcategoryIndex">
					<mat-step label="{{ subcategory.title }}">
						<div *ngFor="let question of subcategory.questions; index as questionIndex" class="padding-top">
							<div
								*ngIf="(selectedCategory.id =='B') ? ( subcategory.id == 1 ) ? (question.id == 40 )? results.categories[selectedCategoryIndex].subcategories[subcategoryIndex].questions[questionIndex-1].score == 2 : true : true : true "
								fxLayout="row"
								fxLayoutAlign="space-around stretch"
								fxLayoutGap="20px"
								class="question-options-text"
							>
								<div fxFlex="40">
									<p>{{ question.text[0] }}</p>
								</div>
								<mat-radio-group *ngIf="question.options != undefined"
												 fxFlex="60"
												 fxLayout="row"
												 fxLayout.lt-md="column"
												 fxLayoutAlign.lt-md="space-between stretch"
												 fxLayoutGap.lt-md="20px"
												 fxLayoutAlign="space-between center"
												 [(ngModel)]="results.categories[selectedCategoryIndex].subcategories[subcategoryIndex].questions[questionIndex].score"
								>
									<mat-radio-button fxFlex="33" *ngFor="let option of question.options; index as optionIndex" [value]="(question.options.length - 1) - optionIndex">{{option}}</mat-radio-button>
								</mat-radio-group>
								<div fxFlex="20" *ngIf="question.text.length > 1">
									<mat-slider
										max="2"
										min="0"
										step="1"
										invert="true"
										value="2"
										tickInterval="1"
										thumbLabel
										fxFill
										[(ngModel)]="results.categories[selectedCategoryIndex].subcategories[subcategoryIndex].questions[questionIndex].score"
										[displayWith]="formatLabel"
									>
									</mat-slider>
								</div>
								<div fxFlex="40" *ngIf="question.text.length > 1">
									<p>{{ question.text[1] }}</p>
								</div>
							</div>
						</div>
						<br />
						<div
							fxLayout="row"
							fxLayoutAlign="space-between center"
						>
							<div>
								<button mat-raised-button color="primary" matStepperPrevious *ngIf="!isFirst">
									Anterior
								</button>
							</div>
							<div>
								<button
									mat-raised-button
									color="primary"
									matStepperNext
									*ngIf="!isLast"
								>
									Siguiente
								</button>

								<button
									mat-raised-button
									(click)="changeModule()"
									color="primary"
									*ngIf="isLast && selectedCategory.id != 'C'"
								>
									Siguiente modulo
								</button>

								<button
									mat-raised-button
									(click)="finish()"
									color="primary"
									*ngIf="isLast && selectedCategory.id == 'C'"
								>
									Finalizar
								</button>
							</div>
						</div>
					</mat-step>
				</div>
			</mat-vertical-stepper>
		</div>
		<app-footer [float]="true"></app-footer>
	</mat-drawer-content>
</mat-drawer-container>
